export class Account {
  id: number;
  account_id: string;
  account_name: string;
}
